module.exports = __webpack_public_path__ + "static/img/footer.0c4c020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/footer.png
// module id = /stY
// module chunks = 1